var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDownYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1574",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.041,
    height: 22.041,
    viewBox: "0 0 22.041 22.041",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "v4gd6bmksa",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAe5JREFUOI2tlU+S0kAUxn+vQavchaUroLwAN5AbGFdu5wZmTmLceQuZE0y4AZ6A4ModwYUD6aSfi/yhCWEKB1OVSn1dr7/+8stLt3Dh0m0YsHcf0EMIxQQ9zKAAzVPUrnB5gjs8yDRN++bLueFdQP7nM1pEqA3QHNQCFjSvn82dZ1DEuN9fZZplF40r0+IR7AyXUyeszLpaa12Nr9CnjzLN0jNj3d4FWFlXKb2ETbr+xL7OoJw2yU1lGgXY148gAVovp966QjUgUo/36gDK740yABRFhMisNVHPrH0IqHrv2NEiAHNdv4kARLdRQFmucYfgWaYuB2mYdhhLp172I0NpQlSDNkGTUFoeR30pcbe+HMwNqmHbFg2zlzBWPdYbQtOy9YLg1fwb4+YN9b1BdezN9sz79JWJRSam/ppcxZhnEnNab0A3x2Q3MPb5CRsDrPA8buvjdpXEoJKcYGjNTxLUJhcSd+sdiWHoFqC7/9rHg3JhZBSnQHwz47Zr9F6mZNVeMRzGwI9zxkePKxkv5d0hhnoTklGcUUoI7E4Z9zC/nHgHg/YvNu3ct99SXrkJIssX9PES3MQ/Rc6OJgD99SlC7ZfTzd0/MTyt9l7GP+OuR68xUB2mT+UcbIjmc7DjepENziZgE8r9QqZp1jf/L7fVfTZ/QwnPAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 79",
    d: "M11.021 0a10.986 10.986 0 1 1-4.29.866A10.986 10.986 0 0 1 11.021 0z",
    style: {
      fill: "url(#v4gd6bmksa)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3173",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.122 2.125 6.77 7.281l5.04-5.156",
    style: {
      stroke: "none"
    },
    transform: "translate(4.304 7.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77 8.784h-.03a1.508 1.508 0 0 1-1.086-.496L1.006 3.13a1.5 1.5 0 0 1 .11-2.122A1.508 1.508 0 0 1 2.428.654a1.502 1.502 0 0 1 .81.465l3.576 3.967 3.92-4.011a1.52 1.52 0 0 1 .502-.34 1.501 1.501 0 0 1 1.624.315 1.499 1.499 0 0 1 .024 2.126l-5.04 5.156a1.503 1.503 0 0 1-1.074.452z",
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    transform: "translate(4.304 7.044)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDownYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-downYellow.6de260048012ef17e79661b56dfc9381.svg";